import { h } from 'preact';
import { useState } from 'preact/hooks';
import { api, authState } from '../../state/auth.js';

export default function ForcePasswordChange() {
  const [current, setCurrent] = useState('');
  const [next, setNext]       = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (next.length < 8) {
      return setError('Je nieuwe wachtwoord moet minimaal 8 tekens bevatten.');
    }
    if (next !== confirm) {
      return setError('De wachtwoorden komen niet overeen.');
    }

    setSaving(true);
    try {
      await api('/api/users/password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      authState.value = { ...authState.value, mustChangePassword: false };
    } catch (err) {
      const msgs = {
        wrong_password: 'Het huidige wachtwoord klopt niet.',
        invalid_input:  'Vul alle velden in en gebruik 8 tot 72 tekens.',
        same_password:  'Kies een ander wachtwoord dan je huidige.',
        password_recently_used: 'Dit wachtwoord heb je kort geleden al gebruikt. Kies een ander.',
        account_locked: 'Te vaak een verkeerd wachtwoord. Probeer het over 15 minuten opnieuw.',
      };
      setError(msgs[err.code] || 'Er ging iets mis. Probeer het opnieuw.');
      setSaving(false);
    }
  }

  return (
    <div style="position:fixed;inset:0;z-index:9100;display:flex;align-items:center;justify-content:center;padding:16px;background:var(--color-bg)">
      <div style="background:var(--color-surface);border-radius:20px;width:100%;max-width:420px;box-shadow:0 24px 80px rgba(0,0,0,0.18);overflow:hidden">

        <div style="height:4px;background:var(--color-primary)" />

        <div style="padding:32px 32px 0">
          <div style="width:52px;height:52px;border-radius:14px;background:var(--color-bg-secondary);display:flex;align-items:center;justify-content:center;font-size:26px;margin-bottom:20px">
            🔑
          </div>
          <h2 style="font-size:20px;font-weight:800;margin:0 0 8px">Kies een nieuw wachtwoord</h2>
          <p style="font-size:14px;color:var(--color-text-muted);margin:0 0 28px;line-height:1.6">
            Je bent ingelogd met een tijdelijk wachtwoord. Kies een persoonlijk wachtwoord om door te gaan.
          </p>
        </div>

        <form onSubmit={handleSubmit} style="padding:0 32px 32px;display:flex;flex-direction:column;gap:16px">
          <div class="form-group">
            <label class="form-label">Huidig (tijdelijk) wachtwoord</label>
            <input
              class="form-input"
              type="password"
              required
              autoComplete="current-password"
              value={current}
              onInput={e => setCurrent(e.target.value)}
            />
          </div>
          <div class="form-group">
            <label class="form-label">Nieuw wachtwoord</label>
            <input
              class="form-input"
              type="password"
              required
              autoComplete="new-password"
              maxLength={72}
              placeholder="Minimaal 8 tekens"
              value={next}
              onInput={e => setNext(e.target.value)}
            />
          </div>
          <div class="form-group">
            <label class="form-label">Bevestig nieuw wachtwoord</label>
            <input
              class="form-input"
              type="password"
              required
              autoComplete="new-password"
              maxLength={72}
              value={confirm}
              onInput={e => setConfirm(e.target.value)}
            />
          </div>

          {error && (
            <div class="alert alert-error">{error}</div>
          )}

          <button
            type="submit"
            class="btn btn-primary"
            disabled={saving}
            style="width:100%;margin-top:4px"
          >
            {saving ? 'Opslaan…' : 'Wachtwoord instellen'}
          </button>
        </form>
      </div>
    </div>
  );
}
